import Phaser from 'phaser';
import { INVENTIONS } from '../data/inventions';
import { BIG_THINGS } from '../data/bigThings';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  preload() {
    // Map tile — only the WA red-dirt skin is rendered now; the per-state
    // tilesets and ocean anchors were removed with the multi-skin code.
    this.load.image('tile-wa', 'assets/tilesets/wa.png');

    // The Australia silhouette mask — produced by `npm run bake:mask`.
    this.load.json('mask', 'data/australia-mask.json');

    // Invention sprites for the Pokédex (loaded best-effort; cards fall back
    // to "?" placeholder if a sprite hasn't been baked yet).
    for (const inv of INVENTIONS) {
      this.load.image(`inv-${inv.id}`, `assets/inventions/${inv.id}.png`);
    }

    // The Big Things — Australia's iconic roadside-attraction sculptures
    // unlocked at milestone solves. Each PNG is loaded best-effort; missing
    // sprites just render as a "?" placeholder.
    for (const bt of BIG_THINGS) {
      this.load.image(`bigthing-${bt.id}`, `assets/bigthings/${bt.id}.png`);
    }

    // Misc UI sprites:
    //  - mystery-box        : gift box in the mobile progress bar
    //  - australia          : smoother silhouette used as the favicon
    //  - australia-chunky   : 8-bit blocky variant for the intro emblem
    this.load.image('mystery-box', 'assets/misc/mystery-box.png');
    this.load.image('australia', 'assets/misc/australia.png');
    this.load.image('australia-chunky', 'assets/misc/australia-chunky.png');
    this.load.image('trophy', 'assets/misc/thumbs-up-trophy.png');
    this.load.image('red-x', 'assets/misc/red-x.png');

    // Don't crash on missing files — log and continue.
    this.load.on('loaderror', (file: Phaser.Loader.File) => {
      console.warn(`(boot) missing asset: ${file.key} (${file.src})`);
    });
  }

  create() {
    this.scene.start('Continent');
  }
}
